export let helpLink = "ztzW7d";
export default {helpLink};